/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { ParticipantStageStatusDto } from '../models';
// @ts-ignore
import type { PracticalExamStatisticsDto } from '../models';
/**
 * PracticalExamStatisticsApi - axios parameter creator
 * @export
 */
export const PracticalExamStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Te same dane co `getPracticalExamStatistics`, wyeksportowane jako wieloarkuszowy plik `.xlsx` (Podsumowanie / Per obszar / Per region / Per sklep / Per osoba). 
         * @summary Export practical exam (Stage 3) statistics as XLSX
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] 
         * @param {Array<string>} [positionCodes] 
         * @param {Array<string>} [regionCodes] 
         * @param {Array<ParticipantStageStatusDto>} [examStatus] 
         * @param {string} [examDayId] 
         * @param {boolean} [examPassed] 
         * @param {number} [examAttemptsMin] 
         * @param {number} [examAttemptsMax] 
         * @param {Array<string>} [examLocations] 
         * @param {Array<string>} [examCommissionMemberIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPracticalExamStatistics: async (certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, examStatus?: Array<ParticipantStageStatusDto>, examDayId?: string, examPassed?: boolean, examAttemptsMin?: number, examAttemptsMax?: number, examLocations?: Array<string>, examCommissionMemberIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('exportPracticalExamStatistics', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('exportPracticalExamStatistics', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/practical-exam-statistics/export`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (positionCodes) {
                localVarQueryParameter['positionCodes'] = positionCodes.join(COLLECTION_FORMATS.csv);
            }

            if (regionCodes) {
                localVarQueryParameter['regionCodes'] = regionCodes.join(COLLECTION_FORMATS.csv);
            }

            if (examStatus) {
                localVarQueryParameter['examStatus'] = examStatus.join(COLLECTION_FORMATS.csv);
            }

            if (examDayId !== undefined) {
                localVarQueryParameter['examDayId'] = examDayId;
            }

            if (examPassed !== undefined) {
                localVarQueryParameter['examPassed'] = examPassed;
            }

            if (examAttemptsMin !== undefined) {
                localVarQueryParameter['examAttemptsMin'] = examAttemptsMin;
            }

            if (examAttemptsMax !== undefined) {
                localVarQueryParameter['examAttemptsMax'] = examAttemptsMax;
            }

            if (examLocations) {
                localVarQueryParameter['examLocations'] = examLocations.join(COLLECTION_FORMATS.csv);
            }

            if (examCommissionMemberIds) {
                localVarQueryParameter['examCommissionMemberIds'] = examCommissionMemberIds.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zwraca zagregowane wyniki egzaminu praktycznego dla WSZYSTKICH uczestników pasujących do filtrów z widoku uczestników (ignoruje paginację). Cztery niezależne przekroje: per obszar, per region, per sklep (lokalizacja egzaminu) i per osoba. Dla każdej osoby brany jest dzień egzaminu o najwyższym wyniku. Metryki obszaru: średni % punktów oraz zdawalność (odsetek zaliczonych obszarów, liczony z zamkniętych). 
         * @summary Get practical exam (Stage 3) statistics for the filtered participants
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] 
         * @param {Array<string>} [positionCodes] 
         * @param {Array<string>} [regionCodes] 
         * @param {Array<ParticipantStageStatusDto>} [examStatus] 
         * @param {string} [examDayId] 
         * @param {boolean} [examPassed] 
         * @param {number} [examAttemptsMin] 
         * @param {number} [examAttemptsMax] 
         * @param {Array<string>} [examLocations] 
         * @param {Array<string>} [examCommissionMemberIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamStatistics: async (certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, examStatus?: Array<ParticipantStageStatusDto>, examDayId?: string, examPassed?: boolean, examAttemptsMin?: number, examAttemptsMax?: number, examLocations?: Array<string>, examCommissionMemberIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getPracticalExamStatistics', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getPracticalExamStatistics', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/practical-exam-statistics`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (positionCodes) {
                localVarQueryParameter['positionCodes'] = positionCodes.join(COLLECTION_FORMATS.csv);
            }

            if (regionCodes) {
                localVarQueryParameter['regionCodes'] = regionCodes.join(COLLECTION_FORMATS.csv);
            }

            if (examStatus) {
                localVarQueryParameter['examStatus'] = examStatus.join(COLLECTION_FORMATS.csv);
            }

            if (examDayId !== undefined) {
                localVarQueryParameter['examDayId'] = examDayId;
            }

            if (examPassed !== undefined) {
                localVarQueryParameter['examPassed'] = examPassed;
            }

            if (examAttemptsMin !== undefined) {
                localVarQueryParameter['examAttemptsMin'] = examAttemptsMin;
            }

            if (examAttemptsMax !== undefined) {
                localVarQueryParameter['examAttemptsMax'] = examAttemptsMax;
            }

            if (examLocations) {
                localVarQueryParameter['examLocations'] = examLocations.join(COLLECTION_FORMATS.csv);
            }

            if (examCommissionMemberIds) {
                localVarQueryParameter['examCommissionMemberIds'] = examCommissionMemberIds.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PracticalExamStatisticsApi - functional programming interface
 * @export
 */
export const PracticalExamStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PracticalExamStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Te same dane co `getPracticalExamStatistics`, wyeksportowane jako wieloarkuszowy plik `.xlsx` (Podsumowanie / Per obszar / Per region / Per sklep / Per osoba). 
         * @summary Export practical exam (Stage 3) statistics as XLSX
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] 
         * @param {Array<string>} [positionCodes] 
         * @param {Array<string>} [regionCodes] 
         * @param {Array<ParticipantStageStatusDto>} [examStatus] 
         * @param {string} [examDayId] 
         * @param {boolean} [examPassed] 
         * @param {number} [examAttemptsMin] 
         * @param {number} [examAttemptsMax] 
         * @param {Array<string>} [examLocations] 
         * @param {Array<string>} [examCommissionMemberIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPracticalExamStatistics(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, examStatus?: Array<ParticipantStageStatusDto>, examDayId?: string, examPassed?: boolean, examAttemptsMin?: number, examAttemptsMax?: number, examLocations?: Array<string>, examCommissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPracticalExamStatistics(certificationId, stageId, search, positionCodes, regionCodes, examStatus, examDayId, examPassed, examAttemptsMin, examAttemptsMax, examLocations, examCommissionMemberIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamStatisticsApi.exportPracticalExamStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zwraca zagregowane wyniki egzaminu praktycznego dla WSZYSTKICH uczestników pasujących do filtrów z widoku uczestników (ignoruje paginację). Cztery niezależne przekroje: per obszar, per region, per sklep (lokalizacja egzaminu) i per osoba. Dla każdej osoby brany jest dzień egzaminu o najwyższym wyniku. Metryki obszaru: średni % punktów oraz zdawalność (odsetek zaliczonych obszarów, liczony z zamkniętych). 
         * @summary Get practical exam (Stage 3) statistics for the filtered participants
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] 
         * @param {Array<string>} [positionCodes] 
         * @param {Array<string>} [regionCodes] 
         * @param {Array<ParticipantStageStatusDto>} [examStatus] 
         * @param {string} [examDayId] 
         * @param {boolean} [examPassed] 
         * @param {number} [examAttemptsMin] 
         * @param {number} [examAttemptsMax] 
         * @param {Array<string>} [examLocations] 
         * @param {Array<string>} [examCommissionMemberIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPracticalExamStatistics(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, examStatus?: Array<ParticipantStageStatusDto>, examDayId?: string, examPassed?: boolean, examAttemptsMin?: number, examAttemptsMax?: number, examLocations?: Array<string>, examCommissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamStatisticsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPracticalExamStatistics(certificationId, stageId, search, positionCodes, regionCodes, examStatus, examDayId, examPassed, examAttemptsMin, examAttemptsMax, examLocations, examCommissionMemberIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamStatisticsApi.getPracticalExamStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PracticalExamStatisticsApi - factory interface
 * @export
 */
export const PracticalExamStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PracticalExamStatisticsApiFp(configuration)
    return {
        /**
         * Te same dane co `getPracticalExamStatistics`, wyeksportowane jako wieloarkuszowy plik `.xlsx` (Podsumowanie / Per obszar / Per region / Per sklep / Per osoba). 
         * @summary Export practical exam (Stage 3) statistics as XLSX
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] 
         * @param {Array<string>} [positionCodes] 
         * @param {Array<string>} [regionCodes] 
         * @param {Array<ParticipantStageStatusDto>} [examStatus] 
         * @param {string} [examDayId] 
         * @param {boolean} [examPassed] 
         * @param {number} [examAttemptsMin] 
         * @param {number} [examAttemptsMax] 
         * @param {Array<string>} [examLocations] 
         * @param {Array<string>} [examCommissionMemberIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPracticalExamStatistics(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, examStatus?: Array<ParticipantStageStatusDto>, examDayId?: string, examPassed?: boolean, examAttemptsMin?: number, examAttemptsMax?: number, examLocations?: Array<string>, examCommissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportPracticalExamStatistics(certificationId, stageId, search, positionCodes, regionCodes, examStatus, examDayId, examPassed, examAttemptsMin, examAttemptsMax, examLocations, examCommissionMemberIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Zwraca zagregowane wyniki egzaminu praktycznego dla WSZYSTKICH uczestników pasujących do filtrów z widoku uczestników (ignoruje paginację). Cztery niezależne przekroje: per obszar, per region, per sklep (lokalizacja egzaminu) i per osoba. Dla każdej osoby brany jest dzień egzaminu o najwyższym wyniku. Metryki obszaru: średni % punktów oraz zdawalność (odsetek zaliczonych obszarów, liczony z zamkniętych). 
         * @summary Get practical exam (Stage 3) statistics for the filtered participants
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] 
         * @param {Array<string>} [positionCodes] 
         * @param {Array<string>} [regionCodes] 
         * @param {Array<ParticipantStageStatusDto>} [examStatus] 
         * @param {string} [examDayId] 
         * @param {boolean} [examPassed] 
         * @param {number} [examAttemptsMin] 
         * @param {number} [examAttemptsMax] 
         * @param {Array<string>} [examLocations] 
         * @param {Array<string>} [examCommissionMemberIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamStatistics(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, examStatus?: Array<ParticipantStageStatusDto>, examDayId?: string, examPassed?: boolean, examAttemptsMin?: number, examAttemptsMax?: number, examLocations?: Array<string>, examCommissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamStatisticsDto> {
            return localVarFp.getPracticalExamStatistics(certificationId, stageId, search, positionCodes, regionCodes, examStatus, examDayId, examPassed, examAttemptsMin, examAttemptsMax, examLocations, examCommissionMemberIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PracticalExamStatisticsApi - interface
 * @export
 * @interface PracticalExamStatisticsApi
 */
export interface PracticalExamStatisticsApiInterface {
    /**
     * Te same dane co `getPracticalExamStatistics`, wyeksportowane jako wieloarkuszowy plik `.xlsx` (Podsumowanie / Per obszar / Per region / Per sklep / Per osoba). 
     * @summary Export practical exam (Stage 3) statistics as XLSX
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} [search] 
     * @param {Array<string>} [positionCodes] 
     * @param {Array<string>} [regionCodes] 
     * @param {Array<ParticipantStageStatusDto>} [examStatus] 
     * @param {string} [examDayId] 
     * @param {boolean} [examPassed] 
     * @param {number} [examAttemptsMin] 
     * @param {number} [examAttemptsMax] 
     * @param {Array<string>} [examLocations] 
     * @param {Array<string>} [examCommissionMemberIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamStatisticsApiInterface
     */
    exportPracticalExamStatistics(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, examStatus?: Array<ParticipantStageStatusDto>, examDayId?: string, examPassed?: boolean, examAttemptsMin?: number, examAttemptsMax?: number, examLocations?: Array<string>, examCommissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Zwraca zagregowane wyniki egzaminu praktycznego dla WSZYSTKICH uczestników pasujących do filtrów z widoku uczestników (ignoruje paginację). Cztery niezależne przekroje: per obszar, per region, per sklep (lokalizacja egzaminu) i per osoba. Dla każdej osoby brany jest dzień egzaminu o najwyższym wyniku. Metryki obszaru: średni % punktów oraz zdawalność (odsetek zaliczonych obszarów, liczony z zamkniętych). 
     * @summary Get practical exam (Stage 3) statistics for the filtered participants
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} [search] 
     * @param {Array<string>} [positionCodes] 
     * @param {Array<string>} [regionCodes] 
     * @param {Array<ParticipantStageStatusDto>} [examStatus] 
     * @param {string} [examDayId] 
     * @param {boolean} [examPassed] 
     * @param {number} [examAttemptsMin] 
     * @param {number} [examAttemptsMax] 
     * @param {Array<string>} [examLocations] 
     * @param {Array<string>} [examCommissionMemberIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamStatisticsApiInterface
     */
    getPracticalExamStatistics(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, examStatus?: Array<ParticipantStageStatusDto>, examDayId?: string, examPassed?: boolean, examAttemptsMin?: number, examAttemptsMax?: number, examLocations?: Array<string>, examCommissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamStatisticsDto>;

}

/**
 * PracticalExamStatisticsApi - object-oriented interface
 * @export
 * @class PracticalExamStatisticsApi
 * @extends {BaseAPI}
 */
export class PracticalExamStatisticsApi extends BaseAPI implements PracticalExamStatisticsApiInterface {
    /**
     * Te same dane co `getPracticalExamStatistics`, wyeksportowane jako wieloarkuszowy plik `.xlsx` (Podsumowanie / Per obszar / Per region / Per sklep / Per osoba). 
     * @summary Export practical exam (Stage 3) statistics as XLSX
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} [search] 
     * @param {Array<string>} [positionCodes] 
     * @param {Array<string>} [regionCodes] 
     * @param {Array<ParticipantStageStatusDto>} [examStatus] 
     * @param {string} [examDayId] 
     * @param {boolean} [examPassed] 
     * @param {number} [examAttemptsMin] 
     * @param {number} [examAttemptsMax] 
     * @param {Array<string>} [examLocations] 
     * @param {Array<string>} [examCommissionMemberIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamStatisticsApi
     */
    public exportPracticalExamStatistics(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, examStatus?: Array<ParticipantStageStatusDto>, examDayId?: string, examPassed?: boolean, examAttemptsMin?: number, examAttemptsMax?: number, examLocations?: Array<string>, examCommissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig) {
        return PracticalExamStatisticsApiFp(this.configuration).exportPracticalExamStatistics(certificationId, stageId, search, positionCodes, regionCodes, examStatus, examDayId, examPassed, examAttemptsMin, examAttemptsMax, examLocations, examCommissionMemberIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zwraca zagregowane wyniki egzaminu praktycznego dla WSZYSTKICH uczestników pasujących do filtrów z widoku uczestników (ignoruje paginację). Cztery niezależne przekroje: per obszar, per region, per sklep (lokalizacja egzaminu) i per osoba. Dla każdej osoby brany jest dzień egzaminu o najwyższym wyniku. Metryki obszaru: średni % punktów oraz zdawalność (odsetek zaliczonych obszarów, liczony z zamkniętych). 
     * @summary Get practical exam (Stage 3) statistics for the filtered participants
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} [search] 
     * @param {Array<string>} [positionCodes] 
     * @param {Array<string>} [regionCodes] 
     * @param {Array<ParticipantStageStatusDto>} [examStatus] 
     * @param {string} [examDayId] 
     * @param {boolean} [examPassed] 
     * @param {number} [examAttemptsMin] 
     * @param {number} [examAttemptsMax] 
     * @param {Array<string>} [examLocations] 
     * @param {Array<string>} [examCommissionMemberIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamStatisticsApi
     */
    public getPracticalExamStatistics(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, examStatus?: Array<ParticipantStageStatusDto>, examDayId?: string, examPassed?: boolean, examAttemptsMin?: number, examAttemptsMax?: number, examLocations?: Array<string>, examCommissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig) {
        return PracticalExamStatisticsApiFp(this.configuration).getPracticalExamStatistics(certificationId, stageId, search, positionCodes, regionCodes, examStatus, examDayId, examPassed, examAttemptsMin, examAttemptsMax, examLocations, examCommissionMemberIds, options).then((request) => request(this.axios, this.basePath));
    }
}

